import React from 'react';
import { saveUnsavedDailyShifts } from '../actions';
import { useDispatch } from 'react-redux';

const SaveUnsavedShiftsButton = ({ restaurantId, date }) => {
  const dispatch = useDispatch();
  return (
    <button
      onClick={() => {
        dispatch(saveUnsavedDailyShifts(restaurantId, date));
      }}
    >
      Save All Unsaved Shifts
    </button>
  );
};

export default SaveUnsavedShiftsButton;
